module.exports = __webpack_public_path__ + "static/media/dolly.54db1eed.svg";